import CreditReviewerSettings from './CreditReviewerSettings';
import ScorecardSettings from './ScorecardSettings';

export default function ApprovalWorkflows() {
  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <div className="sticky top-0 z-10 bg-gray-50 border-b border-gray-100 px-5 py-4 shrink-0">
        <h1 className="text-base font-semibold text-gray-900">Approval Workflows</h1>
        <p className="text-xs text-gray-400 mt-0.5">
          Configure credit reviewer assignments, routing rules, and scorecard settings
        </p>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        <div className="w-full mx-auto flex flex-col gap-4">
          <CreditReviewerSettings />
          {process.env.REACT_APP_ENVIRONMENT !== 'production' && <ScorecardSettings />}
        </div>
      </div>
    </div>
  );
}
